import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

function AssistantIA() {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([
    { text: "Bonjour ! Je suis votre expert en conformité. Comment puis-je vous aider aujourd'hui ? (RGPD, IA Act, Cybersécurité...)", sender: 'ai' }
  ]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);

  // 🌍 Récupération de l'URL API
  const API_URL = process.env.REACT_APP_API_URL;

  // Sécurité : Vérifier si l'utilisateur est connecté au chargement de la page
  useEffect(() => {
    const user = localStorage.getItem('user');
    if (!user) {
      navigate('/login');
    }
  }, [navigate]);

  // Scroll automatique vers le bas lors d'un nouveau message
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Fonction d'envoi du message
  const handleSend = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMsg = input;
    
    // 👉 On récupère l'ID de l'utilisateur connecté depuis le localStorage
    let userId = null;
    try {
      const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
      userId = storedUser.id;
    } catch (error) {
      console.error("Erreur lors de la lecture de l'utilisateur", error);
    }

    // Affichage immédiat du message de l'utilisateur
    setInput("");
    setMessages(prev => [...prev, { text: userMsg, sender: 'user' }]);
    setIsTyping(true);

    try {
      // 👉 On envoie la question ET l'user_id au serveur Cloud (ou Local)
      const response = await fetch(`${API_URL}/ask-ai`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question: userMsg, user_id: userId })
      });
      
      const data = await response.json();
      
      // 👉 On affiche la réponse de l'IA (le backend renvoie "response")
      if (data.response) {
        setMessages(prev => [...prev, { text: data.response, sender: 'ai' }]);
      } else {
        setMessages(prev => [...prev, { text: "Désolé, une erreur est survenue côté serveur.", sender: 'ai' }]);
      }
    } catch (error) {
      setMessages(prev => [...prev, { text: `Désolé, j'ai rencontré une erreur de connexion au serveur (${API_URL} est-il joignable ?).`, sender: 'ai' }]);
    } finally {
      setIsTyping(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', height: '85vh', display: 'flex', flexDirection: 'column', fontFamily: 'Arial' }}>
      
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h2 style={{ color: '#2c3e50', margin: 0 }}>🤖 Assistant IA Expert</h2>
        <p style={{ color: '#7f8c8d', fontSize: '14px' }}>Posez vos questions sur la conformité et la sécurité.</p>
      </div>

      {/* ZONE DES MESSAGES */}
      <div style={{ 
        flex: 1, 
        overflowY: 'auto', 
        background: '#f8f9fa', 
        borderRadius: '15px', 
        padding: '20px', 
        border: '1px solid #eee',
        marginBottom: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px'
      }}>
        {messages.map((m, i) => (
          <div key={i} style={{ 
            alignSelf: m.sender === 'user' ? 'flex-end' : 'flex-start',
            maxWidth: '80%',
            padding: '12px 18px',
            borderRadius: m.sender === 'user' ? '15px 15px 0 15px' : '15px 15px 15px 0',
            background: m.sender === 'user' ? '#3498db' : 'white',
            color: m.sender === 'user' ? 'white' : '#2c3e50',
            boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
            lineHeight: '1.5',
            whiteSpace: 'pre-wrap' /* Permet de conserver les sauts de ligne de l'IA */
          }}>
            {m.text}
          </div>
        ))}
        {isTyping && (
          <div style={{ alignSelf: 'flex-start', color: '#bdc3c7', fontSize: '13px', fontStyle: 'italic' }}>
            L'expert analyse votre demande...
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      {/* BARRE D'ENTRÉE */}
      <form onSubmit={handleSend} style={{ display: 'flex', gap: '10px' }}>
        <input 
          type="text" 
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ex: Quelles sont les sanctions pour un défaut de MFA ?"
          disabled={isTyping}
          style={{ 
            flex: 1, 
            padding: '15px', 
            borderRadius: '10px', 
            border: '2px solid #eee', 
            outline: 'none',
            fontSize: '16px'
          }}
        />
        <button type="submit" disabled={isTyping} style={{ 
          padding: '0 25px', 
          background: isTyping ? '#95a5a6' : '#2c3e50', 
          color: 'white', 
          border: 'none', 
          borderRadius: '10px', 
          fontWeight: 'bold', 
          cursor: isTyping ? 'not-allowed' : 'pointer' 
        }}>
          Envoyer
        </button>
      </form>

      <p style={{ textAlign: 'center', fontSize: '11px', color: '#bdc3c7', marginTop: '10px' }}>
        Assistant basé sur les référentiels ANSSI, RGPD et AI ACT.
      </p>
    </div>
  );
}

export default AssistantIA;